
import { Link } from 'react-router-dom';
import Button from '../../components/base/Button';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Home() {
  const portfolioItems = [
    {
      id: 1,
      title: 'Modern Residential Construction',
      image: 'https://public.readdy.ai/ai/img_res/ac7eda37fb81b308645dcb0a9b656a5b.jpg',
      category: 'Construction'
    },
    {
      id: 2,
      title: 'Garden Landscape Design',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20garden%20landscape%20design%20with%20lush%20green%20grass%2C%20colorful%20flowers%2C%20stone%20pathways%2C%20professional%20landscaping%2C%20outdoor%20living%20space%2C%20natural%20beauty%2C%20well%20maintained%20garden&width=400&height=300&seq=2&orientation=landscape',
      category: 'Landscape'
    },
    {
      id: 3,
      title: 'Commercial Building Project',
      image: 'https://readdy.ai/api/search-image?query=Commercial%20building%20construction%20project%20with%20red%20brick%20facade%2C%20modern%20architecture%2C%20professional%20construction%20work%2C%20urban%20development%2C%20business%20district%2C%20high%20quality%20materials&width=400&height=300&seq=3&orientation=landscape',
      category: 'Construction'
    },
    {
      id: 4,
      title: 'Backyard Transformation',
      image: 'https://readdy.ai/api/search-image?query=Backyard%20transformation%20with%20beautiful%20green%20lawn%2C%20outdoor%20patio%2C%20landscaping%20design%2C%20garden%20features%2C%20outdoor%20furniture%2C%20family%20friendly%20space%2C%20professional%20landscaping%20work&width=400&height=300&seq=4&orientation=landscape',
      category: 'Landscape'
    }
  ];

  const testimonials = [
    {
      id: 1,
      name: 'Sarah Johnson',
      text: 'BrickGreen transformed our backyard into a beautiful oasis. Their attention to detail is exceptional!',
      image: 'https://readdy.ai/api/search-image?query=Happy%20professional%20woman%20client%20smiling%2C%20satisfied%20customer%2C%20portrait%20photo%2C%20natural%20lighting%2C%20friendly%20expression%2C%20business%20casual%20attire%2C%20positive%20testimonial&width=80&height=80&seq=5&orientation=squarish',
      project: 'Landscape Design'
    },
    {
      id: 2,
      name: 'Mike Chen',
      text: 'The construction quality exceeded our expectations. Professional team, on time, on budget.',
      image: 'https://readdy.ai/api/search-image?query=Happy%20professional%20man%20client%20smiling%2C%20satisfied%20customer%2C%20portrait%20photo%2C%20natural%20lighting%2C%20friendly%20expression%2C%20business%20casual%20attire%2C%20positive%20testimonial&width=80&height=80&seq=6&orientation=squarish',
      project: 'Home Addition'
    },
    {
      id: 3,
      name: 'Emily Rodriguez',
      text: 'From design to completion, BrickGreen delivered excellence. Highly recommend their services!',
      image: 'https://readdy.ai/api/search-image?query=Happy%20professional%20woman%20client%20smiling%2C%20satisfied%20customer%2C%20portrait%20photo%2C%20natural%20lighting%2C%20friendly%20expression%2C%20business%20casual%20attire%2C%20positive%20testimonial&width=80&height=80&seq=7&orientation=squarish',
      project: 'Garden Renovation'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative h-screen flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url('https://readdy.ai/api/search-image?query=Professional%20construction%20and%20landscaping%20company%20hero%20background%20with%20red%20brick%20buildings%2C%20green%20grass%20lawns%2C%20construction%20equipment%2C%20beautiful%20outdoor%20spaces%2C%20modern%20architecture%2C%20natural%20lighting%2C%20high%20quality%20professional%20work&width=1920&height=1080&seq=8&orientation=landscape')`
        }}
      >
        <div className="text-center text-white max-w-4xl mx-auto px-4">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Building Dreams, Creating Beauty
          </h1>
          <p className="text-xl md:text-2xl mb-8">
            Professional construction and landscaping services that transform your vision into reality
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact">
              <Button size="lg" className="bg-red-700 hover:bg-red-800">
                Get Free Quote
              </Button>
            </Link>
            <Link to="/portfolio">
              <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-gray-900">
                View Our Work
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Services</h2>
            <p className="text-xl text-gray-600">Comprehensive solutions for all your construction and landscaping needs</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {/* Construction */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20construction%20work%20with%20red%20brick%20materials%2C%20construction%20workers%2C%20building%20site%2C%20modern%20architecture%2C%20construction%20equipment%2C%20high%20quality%20workmanship%2C%20professional%20construction%20company&width=600&height=400&seq=9&orientation=landscape"
                alt="Construction Services"
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Construction Services</h3>
                <p className="text-gray-600 mb-6">
                  From residential homes to commercial buildings, we deliver quality construction with attention to detail and craftsmanship.
                </p>
                <ul className="space-y-2 mb-6">
                  <li className="flex items-center text-gray-700">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    Residential Construction
                  </li>
                  <li className="flex items-center text-gray-700">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    Commercial Buildings
                  </li>
                  <li className="flex items-center text-gray-700">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    Renovations & Additions
                  </li>
                </ul>
                <Link to="/construction">
                  <Button variant="primary">Learn More</Button>
                </Link>
              </div>
            </div>

            {/* Landscaping */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Beautiful%20landscaping%20work%20with%20lush%20green%20grass%2C%20garden%20design%2C%20outdoor%20spaces%2C%20professional%20landscaping%2C%20natural%20beauty%2C%20well%20maintained%20gardens%2C%20landscape%20architecture%2C%20outdoor%20living&width=600&height=400&seq=10&orientation=landscape"
                alt="Landscaping Services"
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Landscape Services</h3>
                <p className="text-gray-600 mb-6">
                  Transform your outdoor spaces with our professional landscaping services, creating beautiful and functional environments.
                </p>
                <ul className="space-y-2 mb-6">
                  <li className="flex items-center text-gray-700">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    Garden Design & Installation
                  </li>
                  <li className="flex items-center text-gray-700">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    Lawn Care & Maintenance
                  </li>
                  <li className="flex items-center text-gray-700">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    Hardscape & Outdoor Living
                  </li>
                </ul>
                <Link to="/landscape">
                  <Button variant="secondary">Learn More</Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Portfolio Preview */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Recent Projects</h2>
            <p className="text-xl text-gray-600">See our latest work and completed projects</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {portfolioItems.map((item) => (
              <div key={item.id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                <img 
                  src={item.image}
                  alt={item.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-6">
                  <span className="inline-block px-3 py-1 text-sm font-medium text-white bg-red-700 rounded-full mb-2">
                    {item.category}
                  </span>
                  <h3 className="text-lg font-semibold text-gray-900">{item.title}</h3>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-12">
            <Link to="/portfolio">
              <Button size="lg">View All Projects</Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Happy Clients</h2>
            <p className="text-xl text-gray-600">What our customers say about our work</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="bg-white rounded-lg shadow-lg p-8">
                <div className="flex items-center mb-4">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full object-cover mr-4"
                  />
                  <div>
                    <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                    <p className="text-sm text-gray-600">{testimonial.project}</p>
                  </div>
                </div>
                <p className="text-gray-700 italic">"{testimonial.text}"</p>
                <div className="flex text-yellow-400 mt-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill"></i>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-red-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-4">Ready to Start Your Project?</h2>
          <p className="text-xl text-red-100 mb-8">
            Contact us today for a free consultation and quote
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact">
              <Button size="lg" className="bg-white text-red-700 hover:bg-gray-100">
                Get Free Quote
              </Button>
            </Link>
            <a href="tel:555-123-4567">
              <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-red-700">
                <i className="ri-phone-line mr-2"></i>
                Call Now
              </Button>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
